module.exports = __webpack_public_path__ + "img/19-Bronze Platin 1.jpg";